export enum ProjectType {
  VISION = 1,
  INTERVU,
  VISIONRAQ,
  INTERVURAQ
}

export const ProjectTypeDisplayName = {
  [ProjectType.VISION]: 'Vision / Book a Project',
  [ProjectType.INTERVU]: 'InterVu / Book a Project',
  [ProjectType.VISIONRAQ]: 'Vision / Request a Quote',
  [ProjectType.INTERVURAQ]: 'InterVu / Request a Quote'
};
